import apiPostRequest from './base/api-post-request'

const userAuthVerify = (email, code, tenant) => apiPostRequest('/auth/verify')({
  email,
  code,
  tenant,
  domain: document.location.hostname
})

export default userAuthVerify